import axios from "axios";
import { API_URL, catchHandler, elseHandler } from "../../helpers/utils";
import { message } from "antd";
import dayjs from "dayjs";

export const GetChallengesAPI =
  ({ page, limit, id, status, search, startDate, endDate, localDate }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/admin`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          status: status,
          startDate: startDate,
          endDate: endDate,
          id: id,
          localDate: localDate,
        },
        // withCredentials: true,
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "user", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetExerciseTypes = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_URL}/challenges/exercise`);

    let result = response.data;

    if (result?.success) {
      return result;
    } else elseHandler(dispatch, "challenges", result?.data);
  } catch (e) {
    catchHandler(dispatch, "challenges");
  }
};

export const CreateChallengeAPI = (data, onFinish) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/challenges`, data);
    if (response.data.success) {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  } finally {
    if (onFinish) {
      onFinish();
    }
  }
};

export const EditChallengeAPI = (data, onFinish) => async (dispatch) => {
  try {
    const response = await axios.put(`${API_URL}/challenges`, data);

    if (response.data.success) {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  } finally {
    if (onFinish) {
      onFinish();
    }
  }
};

export const DeleteChallengeAPI =
  (challengeId, onDelete, onFinish) => async (dispatch) => {
    try {
      const response = await axios.delete(`${API_URL}/challenges`, {
        data: { id: challengeId },
      });

      if (response.data.success) {
        message.success(response.data.message);
        if (onDelete) {
          onDelete();
        }
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    } finally {
      if (onFinish) {
        onFinish();
      }
    }
  };

export const GetChallengeLeaderboardAPI =
  ({ page, limit, challengeId }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/participants`, {
        params: {
          page: page,
          limit: limit,
          challengeId: challengeId,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetChallengeCommentsAPI =
  ({ challengeId }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/comment`, {
        params: {
          challengeId: challengeId,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetUsersToJoinChallengeAPI =
  ({ page, limit, challengeId, search }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/users-list`, {
        params: {
          page: page,
          limit: limit,
          challengeId: challengeId,
          search: search,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const AddUserToChallengeAPI = (data, onFinish) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/challenges/join-user`, data);
    if (response.data.success) {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  } finally {
    if (onFinish) {
      onFinish();
    }
  }
};

export const AddCommentAPI = (data, onFinish) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/challenges/comment`, data);
    if (response.data.success) {
      message.success(response.data.message);
      return response.data;
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  } finally {
    if (onFinish) {
      onFinish();
    }
  }
};

export const GetCommentsAPI =
  ({ challengeId }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/comment`, {
        params: {
          challengeId: challengeId,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetUserActivityLogs = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${API_URL}/challenges/activities/user-logs`,
      data
    );

    let result = response.data;

    if (result?.success) {
      return result;
    } else elseHandler(dispatch, "challenges", result?.data);
  } catch (e) {
    catchHandler(dispatch, "challenges");
  }
};

export const GetUserActivityLogsForChallenge =
  ({ challengeId, userId }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/challenges/challenge-logs`, {
        params: {
          challengeId,
          userId,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const RemoveUserFromChallengeAPI =
  (data, onFinish) => async (dispatch) => {
    try {
      const response = await axios.post(
        `${API_URL}/challenges/remove-user`,
        data
      );

      let result = response.data;

      if (result?.success) {
        if (onFinish) {
          onFinish();
        }
        return result;
      } else elseHandler(dispatch, "challenges", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetNavbarCounts = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_URL}/challenges/sidebar-counts`, {
      params: {
        localDate: dayjs().format("YYYY-MM-DD"),
      },
    });

    let result = response.data;

    if (result?.success) {
      dispatch({
        type: "SET_CHALLENGE_COUNTS",
        payload: {
          pending: result.data?.pendingCount || 0,
          ongoing: result.data?.ongoingCount || 0,
          quizCount: result.data?.quizCount || 0,
          questionCount: result.data?.questionCount || 0,
          inactiveCount: result.data?.inactiveCount || 0,
        },
      });
      return result;
    } else elseHandler(dispatch, "challenges", result?.data);
  } catch (e) {
    catchHandler(dispatch, "challenges");
  }
};

export const SaveBannerAPI = (data, onFinish) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${API_URL}/challenges/challenge-template-images`,
      data
    );
    if (response.data.success) {
      message.success(response.data.message);
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  } finally {
    if (onFinish) {
      onFinish();
    }
  }
};

export const GetBannersAPI =
  ({ page, limit }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(
        `${API_URL}/challenges/challenge-template-images`,
        {
          params: {
            page: page,
            limit: limit,
          },
        }
      );

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "challengesBanner", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challengesBanner");
    }
  };

export const DeleteChallengeBannerAPI =
  (data, onDelete, onFinish) => async (dispatch) => {
    try {
      const response = await axios.delete(
        `${API_URL}/challenges/challenge-template-images`,
        {
          data: data,
        }
      );

      if (response.data.success) {
        message.success(response.data.message);
        if (onDelete) {
          onDelete();
        }
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    } finally {
      if (onFinish) {
        onFinish();
      }
    }
  };
